export const projects = [
    {
      id: 1,
      title: 'FIXED DEPOSIT',
      info: 'A Fixed Deposit (FD) is a financial investment product offered by banks where you deposit a lump sum for a fixed period at a predetermined interest rate. It guarantees a return after maturity, with higher interest rates than regular savings accounts. The tenure can range from a few months to several years, and early withdrawal may incur penalties.',
      position: 'right',
      image: 'https://akm-img-a-in.tosshub.com/businesstoday/images/story/202303/fixed-deposit-sixteen_nine_2.jpg',
      webapp: 'https://example.com/apply/project-two',
    
    },
    {
      id: 2,
      title: 'RECURRING DEPOSIT',
      description: 'An ambitious project aimed at reducing environmental waste through AI solutions.',
      position: 'left',
      image: 'https://www.axisbank.com/images/default-source/progress-with-us_new/advantages-of-a-recurring-deposit-b.jpg',
      webapp: 'https://example.com/apply/project-three',
      info: 'A Recurring Deposit (RD) is a savings scheme offered by banks where you deposit a fixed amount regularly, usually monthly, for a predetermined period. It earns interest at a fixed rate, similar to a Fixed Deposit (FD), but allows for gradual savings over time. At maturity, you receive the deposited amount along with the accumulated interest, making it ideal for disciplined, long-term savings.',
    },
    {
        id: 3,
        title: 'MIS',
        description: 'An ambitious project aimed at reducing environmental waste through AI solutions.',
        position: 'right',
        image: 'https://www.avivaindia.com/sites/default/files/Best%20Income%20Schemes%20in%20India.jpg',
        webapp: 'https://example.com/apply/project-three',
        info: "A Monthly Income Scheme (MIS) is a financial investment plan where you invest a lump sum, and in return, you receive a fixed monthly payout as interest. It’s designed for those seeking regular income, often chosen by retirees or individuals looking for stable, low-risk returns. The principal amount remains safe and is returned at the end of the scheme's tenure.",
      },
  ];
  